// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__vuA-2","with-close":"Pill_with-close__No5r8","with-tooltip":"Pill_with-tooltip__u8hKa"};